import { Button } from './button.js';
import { useCompactGuideActions } from './guides/guide-header-actions.js';
import { ElaraIcon } from './icons/elara-icon.js';

export interface AskElaraButtonProps {
  onClick: () => void;
  className?: string;
  /** Defaults to `icon` in a guide panel's floating header (see `guide-header-actions`), else `default`. */
  variant?: 'default' | 'icon';
  /** Button height for the text variant — `sm` inside a notice, where the full-height button overpowers the copy. */
  size?: 'default' | 'sm';
}

export function AskElaraButton({ onClick, className, variant: variantProp, size = 'default' }: AskElaraButtonProps) {
  const compact = useCompactGuideActions();
  const variant = variantProp ?? (compact ? 'icon' : 'default');
  if (variant === 'icon') {
    return (
      <Button
        variant="icon"
        size={compact ? 'icon-sm' : 'icon'}
        onClick={onClick}
        className={className}
        tooltip="Ask Elara"
        aria-label="Ask Elara"
      >
        <ElaraIcon />
      </Button>
    );
  }

  return (
    <Button variant="outline" size={size} onClick={onClick} className={className}>
      <ElaraIcon /> Ask Elara
    </Button>
  );
}
